export const SET_WAREHOUSES = 'SET_WAREHOUSES';
export const FAILED_GET_WAREHOUSES = 'FAILED_GET_WAREHOUSES';



// WEBPACK FOOTER //
// ./src/state/constants/warehouseConstants.js